<aside class="">
  <section class="ls-sidebar-coll-logo">
    <a routerLink="/admin" class="coll-logo-link pt-2" ngbTooltip="Retour à l'accueil" placement="bottom-left"
       container="body">
      <span class="white-rectangle"></span>
      <img alt="Logo libriciel"
           src="assets/libriciel_color.svg">
    </a>
  </section>
  <section class="ls-sidebar-menu">
    <ul class="main-menu">
      <li routerLinkActive="active">
        <a routerLink="informations">
          <fa-icon icon="info-circle"></fa-icon>
          <span>
            Fil d'information
          </span>
        </a>
        <ul class="sub-menu">
        </ul>
      </li>
      <li routerLinkActive="active">
        <a routerLink="archives">
          <fa-icon icon="archive"></fa-icon>
          <span>
            Archives
          </span>
        </a>
        <ul class="sub-menu">
        </ul>
      </li>
      <li routerLinkActive="active">
        <a routerLink="labels">
          <fa-icon icon="tags"></fa-icon>
          <span>
            Labels
          </span>
        </a>
        <ul class="sub-menu">
        </ul>
      </li>
      <li routerLinkActive="active">
        <a routerLink="faq">
          <fa-icon icon="question"></fa-icon>
          <span>
            Catégories FAQ
          </span>
        </a>
        <ul class="sub-menu">
        </ul>
      </li>
      <li routerLinkActive="active">
        <a routerLink="outils">
          <fa-icon icon="sliders-h"></fa-icon>
          <span>
            Outils
          </span>
        </a>
        <ul class="sub-menu">
        </ul>
      </li>
      <li routerLinkActive="active">
        <a routerLink="evenements">
          <fa-icon icon="calendar"></fa-icon>
          <span>
            Événements
          </span>
        </a>
        <ul class="sub-menu">
        </ul>
      </li>
      <li routerLinkActive="active">
        <a routerLink="demandes">
          <fa-icon icon="user-plus"></fa-icon>
          <span>
            Demandes d'ajout d'utilisateur
            @if(hasUnhandledRequests) {
              <fa-icon icon="circle" class="text-danger"
                       [style.font-size]="'0.7rem'"/>
            }

          </span>
        </a>
        <ul class="sub-menu">
        </ul>
      </li>
      <li routerLinkActive="active">
        <a routerLink="modifications">
          <fa-icon icon="user-edit"></fa-icon>
          <span>
            Modification d'utilisateur
            @if(hasUnhandledEditRequests) {
              <fa-icon icon="circle" class="text-danger"
                       [style.font-size]="'0.7rem'"/>
            }
          </span>
        </a>
        <ul class="sub-menu">
        </ul>
      </li>


      <li routerLinkActive="active">
        <a routerLink="utilisateurs">
          <fa-icon icon="building"></fa-icon>
          <span>
            Utilisateurs client
          </span>
        </a>
        <ul class="sub-menu">
        </ul>
      </li>
      <li>
        <button type="button" class="maintenance-toggle" (click)="confirmMaintenance()"
                ngbTooltip="Activer ou désactiver le mode maintenance" placement="bottom-left" container="body">
          <fa-icon icon="wrench"></fa-icon>
          <span>
            Mode maintenance
            @if(maintenanceEnabled) {
              <fa-icon icon="circle" class="text-danger"
                       [style.font-size]="'0.7rem'"/>
            }
          </span>
        </button>
        <ul class="sub-menu">
        </ul>
      </li>
    </ul>

  </section>
</aside>

<ng-template #maintenanceModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="maintenance-modal-title">
      Mode maintenance
    </h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()">
    </button>
  </div>
  <div class="modal-body">
    @if (maintenanceEnabled) {
      <p>Êtes-vous sûr de désactiver le mode maintenance ?</p>
      <p>Les utilisateurs retrouveront immédiatement accès au portail.</p>
    } @else {
      <p>Êtes-vous sûr de passer en mode maintenance ?</p>
      <p>Les utilisateurs ne pourront plus accéder au portail tant que le mode maintenance est actif.</p>
    }
  </div>
  <div class="modal-footer">
    <app-cancel-button (click)="modal.dismiss()"></app-cancel-button>
    <button type="button" class="btn btn-primary" (click)="modal.close()">Confirmer</button>
  </div>
</ng-template>
